import React, {useState} from 'react';

import {Button, Card, Divider, Form, Input, Space, Typography,} from 'antd';
import {TagIcon,} from 'lucide-react';
import AdminLayout from "@/components/layout/admin/adminLayout";
import {URLS} from "@/lib/urls";
import {Link, useNavigate} from "react-router-dom";

import {useApiCreateAdminDiscount} from "@/api/discount";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {sprintf} from "@/lib/utils/sprintf";

const {Title, Text} = Typography;
const {TextArea} = Input;


export default function AdminDiscountCreatePage() {
    const [form] = Form.useForm();
    const [title, setTitle] = useState('')
    const navigate = useNavigate();

    const {mutate: createDiscount, isPending, isSuccess} = useApiCreateAdminDiscount()

    const onFinish = (values) => {
        values.title = title;
        createDiscount(values, {
            onSuccess: (r) => {
                if (r?.data?.data?.id) {
                    navigate(sprintf(URLS.admin.discount.edit, {id: r?.data?.data?.id}))
                }
                ApiHandleSuccessMessage(r)
            },
            onError: (r) => {
                ApiHandleErrorMessage(r)
            }
        })

    };

    return (
        <AdminLayout pageTitle={'ساخت کد تخفیف'} backTo={URLS.admin.discount.list}>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Space direction="vertical" size="medium" className="w-full">
                    <Card
                        className="shadow-sm"
                        title={
                            <div className="flex items-center gap-2">
                                <TagIcon size={20} className="text-gray-600"/>
                                <span>ایجاد کد تخفیف جدید</span>
                            </div>
                        }
                    >
                        <Form.Item name="title" label="عنوان">
                            <Input size="medium" placeholder="عنوان کد تخفیف" onChange={(e) => {
                                setTitle(e.target.value)
                            }}/>
                            <span className={'text-gray-400'}>بعد از ثبت کد تخفیف می‌توانید سایر تنظیمات آن را مشاده و ویرایش کنید</span>
                        </Form.Item>
                        <Divider/>
                        <div className="flex gap-2 flex-wrap">
                            <div>
                                <Link to={URLS.admin.discount.list}>
                                    <Button size="medium" block>
                                        انصراف
                                    </Button>
                                </Link>
                            </div>
                            <div className={'flex-1'}></div>
                            <div>

                                <Space direction="vertical" size="middle">
                                    <Button
                                        type="primary"
                                        size="medium"
                                        htmlType="submit"
                                        block
                                        // className="!bg-gray-800 hover:!bg-gray-900"
                                    >
                                        ایجاد کد تخفیف
                                    </Button>
                                </Space>
                            </div>
                        </div>
                    </Card>
                </Space>
            </Form>
        </AdminLayout>
    );
}
